$( ->

  # JOB SOURCE SHARE FULL-SCREEN MODAL

  $('body.manage.jobs .promote-job .short_url_form form').bind 'ajax:success', (event,data,status,xhr)->
    $('#source_list').append("<option>#{data.name}</option>")
    $('#source_list option:last').data('source', data)
    $('#source_list').val(data.name)
    $('#source_list').trigger('change')

    the_popup = window.get_modal_markup()
    source_id = data.source_id

    buttons = """
              <button type="button" class="btn btn-default no">No</button>
              <button type="button" class="btn btn-primary yes">Yes</button>
              """
    the_popup.html(window.get_modal_content('Copy To All Jobs?', '<p>Would you like to add this source to all of your current job postings? This will take a few minutes to complete.</p>', buttons))

    solidify_new_source = ->
      $('.modal').modal('hide')
      $('#get_source_link').click()
      $('.short_url_form').collapse('hide')

    the_popup.find('.modal-footer button.yes').click ->
      url = "/manage/sources/#{source_id}/copy_to_jobs"
      $.ajax({
        url: url,
        dataType: 'json',
        success: (data)->
          solidify_new_source()
      })

    the_popup.find('.modal-footer button.no').click ->
      solidify_new_source()

    the_popup.modal()

  $('body.manage.jobs .job-promote .short_url_form form').bind 'ajax:error', (event,data,status,xhr)->
    $('.short_url_form .alert').remove()
    $('.short_url_form').append("""
      <div class="alert alert-danger alert-dismissible" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        #{data.message}
      </div>
    """)
)
